import React from "react";

import styles from "./DataTable.module.scss";

const SuperScriptAdder = ({ headerName, rowValue, headerId }) => {
  if (!rowValue.hasOwnProperty("scoreId")) {
    if (
      (headerName === "Given Name" || headerName === "Family Name") &&
      rowValue.nameCount > 1
    ) {
      return (
        <span className={styles.base}>
          <sup className={styles.superscript}>{rowValue.nameCount}</sup>
        </span>
      );
    }
    if (
      (headerName === "Address Line" ||
        headerName === "City" ||
        headerName === "State" ||
        headerName === "Postal Code") &&
      rowValue.addressCount > 1
    ) {
      return (
        <span className={styles.base}>
          <sup className={styles.superscript}>{rowValue.addressCount}</sup>
        </span>
      );
    }
    if (headerName === "Other Identifiers" && rowValue.identifierCount > 1) {
      return (
        <span className={styles.base}>
          <sup className={styles.superscript}>{rowValue.identifierCount}</sup>
        </span>
      );
    }

    if (headerName === "Email" && rowValue.emailCount > 1) {
      return (
        <span className={styles.base}>
          <sup className={styles.superscript}>{rowValue.emailCount}</sup>
        </span>
      );
    }

    if (headerName === "Phone" && rowValue.phoneCount > 1) {
      return (
        <span className={styles.base}>
          <sup className={styles.superscript}>{rowValue.phoneCount}</sup>
        </span>
      );
    } else return null;
  } else {
    return (
      <span className={styles.base}>
        <sup className={styles.scoreSuperscript}>
          {rowValue.frequency[headerId]}
        </sup>
      </span>
    );
  }
};

export default SuperScriptAdder;
